export default __webpack_public_path__ + "static/media/purple50Discount@3x.bd13431b.png";